//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { LeadsContext } from "../context/LeadsContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerSearch() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { search, setSearch } = useContext(LeadsContext);
    const { statusFilter, setStatusFilter } = useContext(LeadsContext);
    const { tagFilter, setTagFilter } = useContext(LeadsContext);
    const { currentePage, setCurrentPage } = useContext(LeadsContext);
    const { tagsAvailable, setTagsAvailable } = useContext(LeadsContext);
    const { integrations, setIntegrations } = useContext(LeadsContext);
    const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV DO INPUT DE PESQUISA */}
            <div className="mb-2">

                {/* INPUT DE PESQUISA DE LEAD */}
                <input
                    type="text"
                    placeholder="Buscar por nome, email, telefone ou CPF..."
                    value={search}
                    onChange={(e) => {
                        const valor = e.target.value;
                        setSearch(valor);
                    }}
                    className="h-[40px] w-full sm:max-w-[250px] px-4 py-2 bg-surface-2 border border-white/[0.08] rounded text-sm"
                />

            </div>


            {/* DIV DOS FILTROS DE PESQUISA */}
            <div className="flex flex-wrap items-center gap-2 mb-8">


                {/* FILTRO DE STATUS DE COMPRA*/}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Status de Compra</label>
                    <select
                        value={statusFilter}
                        onChange={(e) => {
                            setStatusFilter(e.target.value)
                            setCurrentPage(1)
                        }}
                        className="h-[40px] truncate bg-surface-2 border border-white/[0.12] px-4 py-2 rounded text-sm text-white focus:outline-none focus:ring-2 focus:ring-brand-500"
                    >
                        <option value="">Todos</option>
                        <option value="true">Comprou</option>
                        <option value="false">Não comprou</option>
                    </select>
                </div>


                {/* FILTRO POR TAG  */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Tag</label>
                    <select
                        value={tagFilter}
                        onChange={(e) => {
                            setTagFilter(e.target.value)
                            setCurrentPage(1)
                        }}
                        className="h-[40px] truncate bg-surface-2 border border-white/[0.12] px-4 py-2 rounded text-sm text-white focus:outline-none focus:ring-2 focus:ring-brand-500"
                    >
                        <option value="">Todas as Tags</option>
                        {tagsAvailable.map(tag => (
                            <option key={tag.id} value={tag.nome}>{tag.nome}</option>
                        ))}
                    </select>
                </div>


                {/* FILTRO POR INTEGRAÇÃO */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Integração</label>
                    <select
                        value={integrationsFilter}
                        onChange={(e) => {
                            console.log("Entrou no onChange")
                            console.log(e.target.value)
                            setIntegrationsFilter(e.target.value != "" ? [e.target.value] : [])
                            setCurrentPage(1)
                        }}
                        className=" truncate bg-surface-2 border border-white/[0.12] px-4 py-2 rounded text-sm text-white focus:outline-none focus:ring-2 focus:ring-brand-500">
                        <option value="">Nenhuma Integração</option>
                        {integrations.map(integration => (
                            <option key={integration.id} value={integration.id}>{integration.nome}</option>
                        ))}
                    </select>
                </div>

            </div>

        </>
    )
}